import { render } from "./BgTemplate.vue?vue&type=template&id=8f453950&scoped=true"
import script from "./BgTemplate.vue?vue&type=script&lang=js"
export * from "./BgTemplate.vue?vue&type=script&lang=js"

import "./BgTemplate.vue?vue&type=style&index=0&id=8f453950&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f453950"]])

export default __exports__